import { useSelector } from "react-redux"
import { RootState, useAppDispatch } from "../../store"
import {
  isIdleTimer,
  isPausedTimer,
  isRunningTimer,
  isStoppedTimer,
  TimerState,
  start,
  stop,
  reset,
  pause,
  resume,
  updateStart,
  updateEnd,
  getElapsedMs,
  getElapsedHours,
} from "../store"

export const useHourReportTimer = () => {
  const state = useSelector<RootState, TimerState>((s) => s.hourReportTimer)
  const dispatch = useAppDispatch()

  const isIdle = isIdleTimer(state)
  const isRunning = isRunningTimer(state)
  const isPaused = isPausedTimer(state)
  const isStopped = isStoppedTimer(state)
  const canStart = isIdle
  const canPause = isRunning
  const canResume = isPaused
  const canStop = isRunning || isPaused
  const canReset = isRunning || isPaused || isStopped

  const startTimer = () => canStart && dispatch(start())
  const pauseTimer = () => canPause && dispatch(pause())
  const resumeTimer = () => canResume && dispatch(resume())
  const stopTimer = () => canStop && dispatch(stop())
  const resetTimer = () => canReset && dispatch(reset())
  const updateStartTime = (startTime: number) => dispatch(updateStart(startTime))
  const updateEndTime = (endTime: number) => dispatch(updateEnd(endTime))

  return {
    state,
    isIdle,
    isRunning,
    isPaused,
    isStopped,
    canStart,
    canPause,
    canResume,
    canStop,
    canReset,
    start: startTimer,
    stop: stopTimer,
    reset: resetTimer,
    pause: pauseTimer,
    resume: resumeTimer,
    updateStartTime,
    updateEndTime,
    elapsedMs: getElapsedMs(state),
    elapsedHours: getElapsedHours(state),
  }
}

export type Timer = ReturnType<typeof useHourReportTimer>
